// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dates[data-v-b16229ca] {\n  white-space: pre-line;\n}\n.dates .component-header[data-v-b16229ca] {\n  font-weight: bold;\n  font-size: 1rem;\n}\n.flex-justify-center[data-v-b16229ca] {\n  justify-content: center;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
